<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useGamesStore } from '@/stores/games';

const games = useGamesStore();
const { getCategories } = storeToRefs(games);

const hasLiveCasino = computed(() =>
  getCategories.value.some(cat => cat.nm?.toLowerCase() == 'live casino')
);
</script>
<template>
    <header id="header" class="bg-[#1e211f]  z-50">
        <nav class="flex justify-between md:justify-center md:gap-10 px-4 text-[10px]">
            <RouterLink class="hm-Link py-2" to="/">
                <div class="cat-icon icon-home w-full h-[17px] text-[#cd6505]"></div>
                {{$t('header.2')}}
            </RouterLink>
            <RouterLink class="hm-Link py-2" to="/sports">
                <div class="cat-icon icon-sports w-full h-[17px] text-[#cd6505]"></div>
                {{$t('header.6')}}
            </RouterLink>
            <RouterLink class="hm-Link py-2" to="/in-play">
                <div class="cat-icon icon-signal w-full h-[17px] text-[#cd6505]"></div>
                {{$t('header.3')}}
            </RouterLink>
            <RouterLink class="hm-Link py-2" to="/my-bets">
                <div class="cat-icon icon-stack w-full h-[17px] text-[#cd6505]"></div>
                {{$t('header.4')}}
            </RouterLink>
            <RouterLink class="hm-Link py-2" to="/casino" v-if="getCategories.length>0">
                 <div class="cat-icon icon-slots3 w-full h-[17px] text-[#cd6505]"></div>
                <div class="relative">
                    {{$t('header.5')}}
                </div>
            </RouterLink>
            <RouterLink 
                class="hm-Link py-2" 
                to="/live-casino" 
                v-if="hasLiveCasino"
                >
                <div class="cat-icon icon-slots w-full h-[17px] text-[#cd6505]"></div>
                <div class="relative">
                    {{$t('header.7')}}
                </div>
            </RouterLink>
        </nav>
    </header>
</template>

<style scoped>
.hm-Padd {
    padding: 0 calc((100vw - 1450px)/2);
}

.hm-Link {
    @apply flex flex-col items-center justify-center gap-2 text-white text-[11px];
}
.hm-Link.router-link-exact-active {
    color: var(--hm-selected);
    /* border-color: var(--hm-selected); */
}
.cat-icon{
    mask-position: center;
    /* mask-size: contain; */
    mask-repeat: no-repeat;
    background-color: #BBBBBB; 
}
.hm-Link.router-link-exact-active .cat-icon{
 background-color: var(--hm-selected);
}
.icon-home {
  mask-image: url("/home-out.svg");
}
.icon-sports {
  mask-image: url("/sports.svg");
}
.icon-signal{
    mask-image: url("/signal.svg");
}
.icon-stack{
    mask-image: url("/stack.svg"); 
}
.icon-slots3{
    mask-image: url("/new.svg"); 
}
.icon-slots{
    mask-image: url("/livecasino.svg"); 
}
.icon-chat{
    mask-image: url("/chat.svg"); 
}
</style>
